<app-header-empty></app-header-empty>
<div class="szlhu-sso-error-wrapper">
  <div class="content">
    <p class="error">{{ errorMsg }}</p>
    <a color="blue-payee" routerLink="/login">{{ "SZAMLAZZHU_SSO_ERROR.LOGIN_LINK" | translate }}</a>
  </div>
</div>
